// @flow

//
// React
//
import React from 'react';

//
// Material UI
//
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

//
// Formatter
//
import {
    fmtDate,
    fmtTime,
    fmtMoney,
    fmtDocumentNumber
} from '../../../../../lib/trix-web-data-commons';

//
// Component
//
const createOpenRetailSaleTableCellRenderer = (cfg: any): any => (props: any): any => {
    const row = (props.row) ? props.row : {};

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                p: 2,
            }}
        >
            <Stack>
                <Typography variant='subtitle1' display='block'>
                    {fmtDocumentNumber(row.documentNo)}
                </Typography>
                <Typography variant='subtitle2' display='block'>
                    {fmtDate(row.documentDate)}
                </Typography>
                <Typography variant='subtitle2' display='block'>
                    {fmtTime(row.documentDate)}
                </Typography>

                <Typography variant='caption' display='block' 
                    sx={{ 
                        fontWeight: 600,
                        paddingTop: 1,
                    }}
                >
                    {(row && row.auditMetaData) ? row.auditMetaData.createdBy : ''}
                </Typography>
            </Stack>

            <Box 
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                }}
            >
                <Typography 
                    variant='subtitle1' 
                    color='text.secondary' 
                    sx={{ textAlign: 'right', width: '100%' }}
                >
                    {fmtMoney(row.stockTotalAmount)}
                </Typography>
            </Box>
        </Box>
    );
}

const createOpenRetailSaleTableColumn = (cfg: any): any => { 
    return {
        flex: true,
        width: 100,

        renderCell: createOpenRetailSaleTableCellRenderer({
            ...cfg.cellRendererFactoryProps,
        })
    }
};
export default createOpenRetailSaleTableColumn;
